// extracted by mini-css-extract-plugin
module.exports = {"component":"SettingsPage_component__XajdI","content":"SettingsPage_content__2JcWf","header":"SettingsPage_header__2t8J9"};